// extracted by mini-css-extract-plugin
export default {"main":"styles_main__VFQFD","container":"styles_container__6PJvB","form":"styles_form__R5bVm","w100":"styles_w100__tRNdA","w50":"styles_w50__nVoqQ","send":"styles_send__vtCyY"};